import { Avatar, Space, Typography } from 'antd';
import React from 'react';
import RocketlaneLogo from 'assets/svgs/rocketlane_icon_standard.svg';
import SalesforceLogo from 'assets/svgs/salesforce-logo.svg';

const { Text } = Typography;

export const DisplayDynamicValue = ({
  valueStr,
  label,
  boldText,
}: {
  valueStr?: string;
  label: string;
  boldText?: boolean;
}) => (
  <Space>
    {valueStr?.startsWith('${trigger.') ? (
      <Avatar src={SalesforceLogo} shape="square" size="small" />
    ) : (
      <Avatar src={RocketlaneLogo} shape="square" size="small" />
    )}
    <Text strong={boldText} ellipsis={{ tooltip: true }}>
      {label}
    </Text>
  </Space>
);
